// CR-1421: Cost tab weekly charts API
import api, { type AxiosResponse } from './client';
import type { CostWeekLinesResponse, CostWeeksChart, CostWeeksResponse } from './types';

type Params = Record<string, string | number | boolean>;

/** Which bar: the chart, its Monday (or "overdue"), and terms group keys ("all" for every group). */
export interface CostWeekBar {
  chart: CostWeeksChart
  week: string
  terms: string
  /** CR-1421 decision 4: "arrears" lists only the lines a goods-in arrears bar counts. */
  subset?: 'arrears'
}

export const costWeeksAPI = {
  /**
   * One page of twelve weeks of both weekly charts.
   * @param params - the dashboard's own Cost request params, plus `page` (0 = this week on)
   */
  getWeeks: (params: Params): Promise<AxiosResponse<CostWeeksResponse>> =>
    api.get('/purchasing/orders/cost_weeks/', { params }),

  /** The PO lines behind one bar, a page at a time. */
  getLines: (params: Params, bar: CostWeekBar, page: number, pageSize: number): Promise<AxiosResponse<CostWeekLinesResponse>> =>
    api.get('/purchasing/orders/cost_week_lines/', { params: { ...params, ...bar, page, page_size: pageSize } }),

  /** Every line behind one bar as an XLSX blob. */
  exportLines: (params: Params, bar: CostWeekBar): Promise<AxiosResponse<Blob>> =>
    api.get('/purchasing/orders/cost_week_lines/', { params: { ...params, ...bar, export: 'xlsx' }, responseType: 'blob' }),
};
